import React, {Component} from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'
import styles from './styles.css'
import CalendarIcon from './assets/calendar-24px.svg'

export default class DateField extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    useHint: PropTypes.bool,
    label: PropTypes.string,
    useLabel: PropTypes.bool,
    errorMessage: PropTypes.string,
    disabled: PropTypes.bool
  }

  render() {
    return (
      <div className={`${styles.DateField} col`}>
        {this.props.useLabel ? (
          <label className="input-label-enabled-color input-label-text">{this.props.label}</label>
        ) : null}
        <div className={`${styles.input_container}`}>
          <DatePicker
            selected={this.props.startDate}
            onChange={this.props.onChange}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            selectsRange
            showIcon={false}
            format="yyyy/MM/dd"
          />
          <img src={CalendarIcon} className={`${styles.ico_calendar}`} alt="calendar icon"></img>
        </div>
        <div className="os-input-error">{this.props.errorMessage}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/Nebula/DateField/index.js